















































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import Vue from "vue";

import { appModule } from "@/store/modules/app";
import { sarcopeniaDiagnosisByUuid } from "@/api/patientsService";
import { patientRecordsModule } from "@/store/modules/patientRecords";

import { GENDER } from "@/utils/store-util";

@Component
export default class SarcopeniaForm extends Vue {
  
  private uuid = "";
  avatar = "";
  
  get patient() {
    return patientRecordsModule.patient;
  }
  get loading() {
    return patientRecordsModule.loading;
  }
  sarcfChangeenabled = false;
  calfChangeenabled = false;
  MSChangeenabled = false;
  ftsstChangeenabled = false;
  walkingChangeenabled = false;
  sbyssChangeenabled = false;
  semitandemChangeenabled = false;
  tandemChangeenabled = false;
  heightChangeenabled = false;
  DXAChangeenabled = false;
  BIAChangeenabled = false;
  SARCFDialog = false;
  PhysicalPerformanceDialog = false;
  ASMDialog = false;
  SARCF_finish = false;
  ASM_finish = false;
  physicalperformance_finish = false;
  sarcopeniaFormData = {
    CALF: null,
    CALF_measureat: null,
    physicalperformance: {
      fivetimestanding: null,
      fivetimestanding_measureat: null,
      sixmetrewalking: null,
      sixmetrewalking_measureat: null,
      sbysstanding: null,
      sbysstanding_measureat: null,
      semitandemstand: null,
      semitandemstand_measureat: null,
      tandemstand: null,
      tandemstand_measureat: null
    },
    musclestrength: null,
    musclestrength_measureat: null,
    gender: "",
    SARCF: {
      SARCF_measureat: null,
      SARCFlifting: null,
      SARCFwalking: null,
      SARCFclimbing: null,
      SARCFfalling: null,
      SARCFstanding: null
    },
    ASM: {
      height: null,
      height_measureat: null,
      DXA: null,
      DXA_measureat: null,
      BIA: null,
      BIA_measureat: null
    }
  };
  has_value(item){
    return (item===null)
      ? false
      : (item===undefined)
        ? false
        : (item==="")
          ? false
          : true;
  }
  async created() {
    this.uuid = this.$router.currentRoute.params.id;
    await this.getPatientByUuid(this.uuid);
    //console.log(this.patient.record);
    this.sarcopeniaFormData.gender = this.patient.user.gender;
    if(this.has_value(this.patient.record.frailty['sarcf']['value'])){
      const tempSarcf = this.patient.record.frailty['sarcf']['value'].split(",");
      this.sarcopeniaFormData.SARCF.SARCFlifting = tempSarcf[0];
      this.sarcopeniaFormData.SARCF.SARCFwalking = tempSarcf[1];
      this.sarcopeniaFormData.SARCF.SARCFstanding = tempSarcf[2];
      this.sarcopeniaFormData.SARCF.SARCFclimbing = tempSarcf[3];
      this.sarcopeniaFormData.SARCF.SARCFfalling = tempSarcf[4];
      this.sarcopeniaFormData.SARCF.SARCF_measureat = this.patient.record.frailty['sarcf']['measure_at'];
    }
    
    if(!this.has_value(this.sarcopeniaFormData.SARCF.SARCF_measureat)) this.sarcfChangeenabled = true;
    
    this.sarcopeniaFormData.CALF = this.patient.record.frailty['calf']['value'];
    if(!this.has_value(this.sarcopeniaFormData.CALF)) this.calfChangeenabled = true;
    this.sarcopeniaFormData.CALF_measureat = this.patient.record.frailty['calf']['measure_at'];
    this.sarcopeniaFormData.musclestrength = this.patient.record.frailty['right_grip']['value'] || this.patient.record.frailty['left_grip']['value'];
    if(!this.has_value(this.sarcopeniaFormData.musclestrength)) this.MSChangeenabled = true;
    this.sarcopeniaFormData.musclestrength_measureat = this.patient.record.frailty['right_grip']['measure_at'] || this.patient.record.frailty['left_grip']['measure_at'];
    this.sarcopeniaFormData.physicalperformance.fivetimestanding = this.patient.record.frailty['ftsst']['value'];
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.fivetimestanding)) this.ftsstChangeenabled = true;
    this.sarcopeniaFormData.physicalperformance.fivetimestanding_measureat = this.patient.record.frailty['ftsst']['measure_at'];
    this.sarcopeniaFormData.physicalperformance.sixmetrewalking = this.patient.record.frailty['walkspeed']['value'];
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.sixmetrewalking)) this.walkingChangeenabled = true;
    this.sarcopeniaFormData.physicalperformance.sixmetrewalking_measureat = this.patient.record.frailty['walkspeed']['measure_at'];
    this.sarcopeniaFormData.physicalperformance.sbysstanding = this.patient.record.frailty['sbyss']['value'];
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.sbysstanding)) this.sbyssChangeenabled = true;
    this.sarcopeniaFormData.physicalperformance.sbysstanding_measureat = this.patient.record.frailty['sbyss']['measure_at'];
    this.sarcopeniaFormData.physicalperformance.semitandemstand = this.patient.record.frailty['semitandem']['value'];
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.semitandemstand)) this.semitandemChangeenabled = true;
    this.sarcopeniaFormData.physicalperformance.semitandemstand_measureat = this.patient.record.frailty['semitandem']['measure_at'];
    this.sarcopeniaFormData.physicalperformance.tandemstand = this.patient.record.frailty['tandem']['value'];
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.tandemstand)) this.tandemChangeenabled = true;
    this.sarcopeniaFormData.physicalperformance.tandemstand_measureat = this.patient.record.frailty['tandem']['measure_at'];
    this.sarcopeniaFormData.ASM.height = this.patient.record.metabolic['height']['value'];
    if(!this.has_value(this.sarcopeniaFormData.ASM.height)) this.heightChangeenabled = true;
    this.sarcopeniaFormData.ASM.height_measureat = this.patient.record.metabolic['height']['measure_at'];
    this.sarcopeniaFormData.ASM.DXA = (this.patient.record.frailty['dxa']['value'])? this.patient.record.frailty['dxa']['value'] * (this.patient.record.metabolic['height']['value']/100)**2 : null;
    if(!this.has_value(this.sarcopeniaFormData.ASM.DXA)) this.DXAChangeenabled = true;
    this.sarcopeniaFormData.ASM.DXA_measureat = this.patient.record.frailty['dxa']['measure_at'];
    this.sarcopeniaFormData.ASM.BIA = (this.patient.record.frailty['bia']['value'])? this.patient.record.frailty['bia']['value'] * (this.patient.record.metabolic['height']['value']/100)**2 : null;
    if(!this.has_value(this.sarcopeniaFormData.ASM.BIA)) this.BIAChangeenabled = true;
    this.sarcopeniaFormData.ASM.BIA_measureat = this.patient.record.frailty['bia']['measure_at'];
  }
  async getPatientByUuid(uuid) {
    await patientRecordsModule.getPatientByUuid(uuid);
  }
  async editSARCF(){
    this.SARCFDialog = true;
  }
  closeSARCF(){
    this.SARCFDialog = false;
  }
  async saveSARCF(){
    if(!this.has_value(this.sarcopeniaFormData.SARCF.SARCFwalking) ||
      !this.has_value(this.sarcopeniaFormData.SARCF.SARCFclimbing) ||
      !this.has_value(this.sarcopeniaFormData.SARCF.SARCFstanding) ||
      !this.has_value(this.sarcopeniaFormData.SARCF.SARCFfalling)){
        appModule.sendErrorNotice("請填完表單");
      }
    else{
      this.SARCF_finish = true;
      this.closeSARCF();
    }
    
  }

  async editPhysicalPerformance(){
    this.PhysicalPerformanceDialog = true;
  }
  closePhysicalPerformance(){
    this.PhysicalPerformanceDialog = false;
  }
  async savePhysicalPerformance(){
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.fivetimestanding) &&
      !this.has_value(this.sarcopeniaFormData.physicalperformance.sixmetrewalking)){
        appModule.sendErrorNotice("5次起立坐下和6公尺走路速度至少填一個");
      }
      else if(
        (!this.has_value(this.sarcopeniaFormData.physicalperformance.fivetimestanding) || !this.has_value(this.sarcopeniaFormData.physicalperformance.sixmetrewalking)) &&
      (this.has_value(this.sarcopeniaFormData.physicalperformance.sbysstanding) || this.has_value(this.sarcopeniaFormData.physicalperformance.semitandemstand) || this.has_value(this.sarcopeniaFormData.physicalperformance.tandemstand))){
        appModule.sendErrorNotice("並排站立,半並排站立,直線站立全填要(包含5次起立坐下和6公尺走路速度)或全不填");
      }
      else{
        this.physicalperformance_finish = true;
        this.closePhysicalPerformance();
      }
    
  }

  async editASM(){
    this.ASMDialog = true;
  }
  closeASM(){
    this.ASMDialog = false;
  }
  async saveASM(){
    if(!this.has_value(this.sarcopeniaFormData.ASM.height) && (this.has_value(this.sarcopeniaFormData.ASM.DXA) || this.has_value(this.sarcopeniaFormData.ASM.BIA))){
      appModule.sendErrorNotice("若填ASM則身高為必填，DXA和BIA二者擇一");
    }
    else{
      this.ASM_finish = true;
      this.closeASM();
    }
    
  }

  async save() {
    if(!this.physicalperformance_finish ||!this.has_value(this.sarcopeniaFormData.musclestrength) || !this.has_value(this.sarcopeniaFormData.gender)){
      appModule.sendErrorNotice("請完成必填項目");
    }
    else if(!this.SARCF_finish && !this.has_value(this.sarcopeniaFormData.CALF)){
      appModule.sendErrorNotice("SARC-F和小腿圍二者擇一");
    }
    else{
      this.sarcopeniaFormData.gender = Object.keys(GENDER).find(
        (key) => GENDER[key] === this.sarcopeniaFormData.gender
      );
      if(this.SARCF_finish){
        Object.keys(this.sarcopeniaFormData.SARCF).forEach(key =>{
          if(key!=='SARCF_measureat') this.sarcopeniaFormData.SARCF[key] = parseInt(this.sarcopeniaFormData.SARCF[key]);
        });
      }
      const params = {};
      const now = Date.now()
      if(this.has_value(this.sarcopeniaFormData.CALF)){
        params['CALF'] = parseFloat(this.sarcopeniaFormData.CALF);
        params['CALF_measureat'] = (this.calfChangeenabled)? now/1000:this.sarcopeniaFormData.CALF_measureat;
      }
      if(this.has_value(this.sarcopeniaFormData.gender)){
        params['gender'] = this.sarcopeniaFormData.gender;
      }
      if(this.has_value(this.sarcopeniaFormData.musclestrength)){
        params['MuscleStrength'] = parseFloat(this.sarcopeniaFormData.musclestrength);
        params['MuscleStrength_measureat'] = (this.MSChangeenabled)? now/1000:this.sarcopeniaFormData.musclestrength_measureat;
      }
      if(this.ASM_finish && this.has_value(this.sarcopeniaFormData.ASM.height) && (this.has_value(this.sarcopeniaFormData.ASM.DXA)|| this.has_value(this.sarcopeniaFormData.ASM.BIA))){
        params['ASM'] = {
          "height": parseFloat(this.sarcopeniaFormData.ASM.height),
          "height_measureat": (this.heightChangeenabled)? now/1000:this.sarcopeniaFormData.ASM.height_measureat,
          "DXA": parseFloat(this.sarcopeniaFormData.ASM.DXA),
          "DXA_measureat":(this.DXAChangeenabled)? now/1000:this.sarcopeniaFormData.ASM.DXA_measureat,
          "BIA": parseFloat(this.sarcopeniaFormData.ASM.BIA),
          "BIA_measureat":(this.BIAChangeenabled)? now/1000:this.sarcopeniaFormData.ASM.BIA_measureat
          }
      }
      
      params['PhysicalPerformance'] = {};
      if(this.physicalperformance_finish && this.has_value(this.sarcopeniaFormData.physicalperformance.fivetimestanding)){
        params['PhysicalPerformance']["5-time-standing"] = parseFloat(this.sarcopeniaFormData.physicalperformance.fivetimestanding);
        params['PhysicalPerformance']["5-time-standing_measureat"] = (this.ftsstChangeenabled)? now/1000:this.sarcopeniaFormData.physicalperformance.fivetimestanding_measureat;
      }
      if(this.physicalperformance_finish && this.has_value(this.sarcopeniaFormData.physicalperformance.sixmetrewalking)){
        params['PhysicalPerformance']["6-metre-walking"] = parseFloat(this.sarcopeniaFormData.physicalperformance.sixmetrewalking);
        params['PhysicalPerformance']["6-metre-walking_measureat"] = (this.walkingChangeenabled)? now/1000:this.sarcopeniaFormData.physicalperformance.sixmetrewalking_measureat;
      }
      if(this.physicalperformance_finish && this.has_value(this.sarcopeniaFormData.physicalperformance.sbysstanding)){
        params['PhysicalPerformance']["s-by-s-standing"] = parseFloat(this.sarcopeniaFormData.physicalperformance.sbysstanding);
        params['PhysicalPerformance']["s-by-s-standing_measureat"] = (this.sbyssChangeenabled)? now/1000:this.sarcopeniaFormData.physicalperformance.sbysstanding_measureat;
      }
      if(this.physicalperformance_finish && this.has_value(this.sarcopeniaFormData.physicalperformance.semitandemstand)){
        params['PhysicalPerformance']["semitandem-stand"] = parseFloat(this.sarcopeniaFormData.physicalperformance.semitandemstand);
        params['PhysicalPerformance']["semitandem-stand_measureat"] = (this.semitandemChangeenabled)? now/1000:this.sarcopeniaFormData.physicalperformance.semitandemstand_measureat;
      }
      if(this.physicalperformance_finish && this.has_value(this.sarcopeniaFormData.physicalperformance.tandemstand)){
        params['PhysicalPerformance']["tandem-stand"] = parseFloat(this.sarcopeniaFormData.physicalperformance.tandemstand);
        params['PhysicalPerformance']["tandem-stand_measureat"] = (this.tandemChangeenabled)? now/1000 : this.sarcopeniaFormData.physicalperformance.tandemstand_measureat;
      }
      if(this.SARCF_finish){
        params["SARC_F"] = {
          'SARCF_measureat': (this.sarcfChangeenabled)? now/1000 : this.sarcopeniaFormData.SARCF.SARCF_measureat,
          'SARC_F-lifting':this.sarcopeniaFormData.SARCF.SARCFlifting,
          'SARC_F-walking':this.sarcopeniaFormData.SARCF.SARCFwalking,
          'SARC_F-standing':this.sarcopeniaFormData.SARCF.SARCFstanding,
          'SARC_F-climbing':this.sarcopeniaFormData.SARCF.SARCFclimbing,
          'SARC_F-falling':this.sarcopeniaFormData.SARCF.SARCFfalling
        }
      }
      const result = await sarcopeniaDiagnosisByUuid(this.uuid, params);
      if(result){
        appModule.sendSuccessNotice(result.status);
      }
    }
  }

  resetForm() {
    this.SARCF_finish = false;
    this.physicalperformance_finish = false;
    this.ASM_finish = false;
    this.sarcopeniaFormData = {
      CALF: this.patient.record.frailty['calf']['value'],
      CALF_measureat: this.patient.record.frailty['calf']['measure_at'],
      physicalperformance: {
        fivetimestanding: this.patient.record.frailty['ftsst']['value'],
        sixmetrewalking: this.patient.record.frailty['walkspeed']['value'],
        fivetimestanding_measureat: this.patient.record.frailty['ftsst']['measure_at'],
        sixmetrewalking_measureat: this.patient.record.frailty['walkspeed']['measure_at'],
        sbysstanding_measureat: this.patient.record.frailty['sbyss']['measure_at'],
        semitandemstand_measureat: this.patient.record.frailty['semitandem']['measure_at'],
        tandemstand_measureat: this.patient.record.frailty['tandem']['measure_at'],
        sbysstanding: this.patient.record.frailty['sbyss']['value'],
        semitandemstand: this.patient.record.frailty['semitandem']['value'],
        tandemstand: this.patient.record.frailty['tandem']['value']
      },
      musclestrength: this.patient.record.frailty['right_grip']['value'] || this.patient.record.frailty['left_grip']['value'],
      musclestrength_measureat: this.patient.record.frailty['right_grip']['measure_at'] || this.patient.record.frailty['left_grip']['measure_at'],
      gender: this.patient.user.gender,
      SARCF: {
        SARCF_measureat: null,
        SARCFlifting: null,
        SARCFwalking: null,
        SARCFclimbing: null,
        SARCFfalling: null,
        SARCFstanding: null
      },
      ASM: {
        height: this.patient.record.metabolic['height']['value'],
        height_measureat: this.patient.record.metabolic['height']['measure_at'],
        DXA: (this.patient.record.frailty['dxa']['value'])? this.patient.record.frailty['dxa']['value'] * (this.patient.record.metabolic['height']['value']/100)**2 : null,
        DXA_measureat: this.patient.record.frailty['dxa']['measure_at'],
        BIA: (this.patient.record.frailty['bia']['value'])? this.patient.record.frailty['bia']['value'] * (this.patient.record.metabolic['height']['value']/100)**2 : null,
        BIA_measureat: this.patient.record.frailty['bia']['measure_at']
      }
    };
    if(this.has_value(this.patient.record.frailty['sarcf']['value'])){
      const tempSarcf = this.patient.record.frailty['sarcf']['value'].split(",");
      this.sarcopeniaFormData.SARCF.SARCFlifting = tempSarcf[0];
      this.sarcopeniaFormData.SARCF.SARCFwalking = tempSarcf[1];
      this.sarcopeniaFormData.SARCF.SARCFstanding = tempSarcf[2];
      this.sarcopeniaFormData.SARCF.SARCFclimbing = tempSarcf[3];
      this.sarcopeniaFormData.SARCF.SARCFfalling = tempSarcf[4];
      this.sarcopeniaFormData.SARCF.SARCF_measureat = this.patient.record.frailty['sarcf']['measure_at'];
      this.sarcfChangeenabled = false;
    }else this.sarcfChangeenabled = true;
    
    if(!this.has_value(this.sarcopeniaFormData.CALF)) this.calfChangeenabled = true;
    else this.calfChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.musclestrength)) this.MSChangeenabled = true;
    else this.MSChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.fivetimestanding)) this.ftsstChangeenabled = true;
    else this.ftsstChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.sixmetrewalking)) this.walkingChangeenabled = true;
    else this.walkingChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.sbysstanding)) this.sbyssChangeenabled = true;
    else this.sbyssChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.semitandemstand)) this.semitandemChangeenabled = true;
    else this.semitandemChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.physicalperformance.tandemstand)) this.tandemChangeenabled = true;
    else this.tandemChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.ASM.height)) this.heightChangeenabled = true;
    else this.heightChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.ASM.DXA)) this.DXAChangeenabled = true;
    else this.DXAChangeenabled = false;
    if(!this.has_value(this.sarcopeniaFormData.ASM.BIA)) this.BIAChangeenabled = true;
    else this.BIAChangeenabled = false;
    appModule.setSnackbar;
  }

  cancel() {
    this.$router.push({
      name: `個案紀錄`,
      params: {
        id: this.$router.currentRoute.params.id,
      },
    });
  }
}
